import * as types from './constants';
import api from '../_api'
// const setParamListNotication = (context, values) => {
//   return context.commit('SET_PARAM_LIST_NOTICATION', values);
// };
const setParamListNotication = ({ commit }, data) => {
    commit(types.SET_PARAM_LIST_NOTICATION, data)
};
export default {
    setParamListNotication
};